import { useEffect, useState } from 'react';
import searchPartners from '../../../../services/searchPartners';
import fetchPartnerUserSavedCounts from "../../../../services/fetchPartnerUserSavedCounts";
import appConstants from "../../../../constants";

//let currentApiCallId;

export default function usePartnerSearch(
  searchCriteria,
  currentPageIndex,
  recordCountPerPage,
  sortingCriteria,
  //isUserGeoLocationCompleted,
  isSearchRequested,
  setIsSearchRequested
) {
  const [ isPartnerSearchInProgress, setIsPartnerSearchInProgress] = useState(false);
  const [ partnerSearchProcessingError, setPartnerSearchProcessingError] = useState(null);

  const [ foundPartners, setFoundPartners ] = useState([]);
  const [ foundPartnerCount, setFoundPartnerCount ] = useState(0);

  useEffect(
    () => {
      async function getMatchingPartners() {

        function getPartnerUserSavedCount(partnerUserSavedCounts, partnerSiteId) {
          const record = partnerUserSavedCounts.partnerUserSavedCounts.filter(partnerUserSavedCount => partnerUserSavedCount[appConstants.KEY_SITEID] === `${partnerSiteId}`);
          return !!record.length ? parseInt(record[0].partnerCount):0;
        }

        //const apiCallId = +(new Date());

        //currentApiCallId = apiCallId;

        let matchingPartners = await searchPartners(searchCriteria, { pageSize: recordCountPerPage, pageCount: currentPageIndex }, sortingCriteria);

        //if (apiCallId !== currentApiCallId && currentApiCallId) {
        //  return;
        //}

        if(!matchingPartners.hasError) {
          if(!!matchingPartners.foundPartners.length) {
            const partnerUserSavedCounts =
              await fetchPartnerUserSavedCounts(
                matchingPartners.foundPartners.map(
                  foundPartner =>
                    foundPartner[appConstants.KEY_SITE_ID_LOWERCASE]).join(',')
              );
            if(!partnerUserSavedCounts.hasError) {
              matchingPartners.foundPartners =
                matchingPartners.foundPartners.map(
                  foundPartner => {
                    return {
                      ...foundPartner,
                      savedCount: getPartnerUserSavedCount(partnerUserSavedCounts,foundPartner[appConstants.KEY_SITE_ID_LOWERCASE])
                    }
                  }
                );
              setPartnerSearchProcessingError(previousValue => null);
              setFoundPartners(previousValue => matchingPartners.foundPartners);
              setFoundPartnerCount(previousValue => matchingPartners.foundPartnerCount);
            }
          }
          else {
            setPartnerSearchProcessingError(null);
            setFoundPartners(previous => []);
            setFoundPartnerCount(previousValue => 0);
          }
        }
        else {
          setPartnerSearchProcessingError(matchingPartners.errorMessage);
          setFoundPartners(previous => []);
          setFoundPartnerCount(previousValue => 0);
        }
        setIsPartnerSearchInProgress(false);
        setIsSearchRequested(false);
      }
      //if(!!searchCriteria && !!searchCriteria.length) {
      if(isSearchRequested) {
        setIsPartnerSearchInProgress(true);
        getMatchingPartners();
        //getMatchingPartners();
        //getMatchingPartners();
      }
    },
    [isSearchRequested]
  )

  return {
    isPartnerSearchInProgress,
    partnerSearchProcessingError,
    foundPartners,
    setFoundPartners,
    foundPartnerCount,
  }
}
